import React from 'react';
import { Link } from 'react-router';
import './breadcrumbs.scss';

/** @import { BreadcrumbLink, BreadcrumbsProps } from './BreadcrumbsTypes' */

const getClassName = (/** @type {boolean} */ withBg) => ['breadcrumbs', withBg ? 'breadcrumbs--with-bg' : ''].join(' ');

const Breadcrumbs = (/** @type {BreadcrumbsProps} */ { links = [], withBg = false }) => {
  return (
    <div className={getClassName(withBg)}>
      <ul className='breadcrumbs__wrapper'>
        { renderBreadcrumbLinks(links) }
      </ul>
    </div>
  );
};

const renderBreadcrumbLinks = (/** @type {BreadcrumbLink[]} */ breadcrumbs) =>
  breadcrumbs.map(({ text, link, isLocal }) => (
    <li key={text} className='breadcrumbs__crumb'>
      {isLocal ? <Link to={link}>{ text }</Link> : <a href={link}>{text}</a>}
    </li>
  ));


export default Breadcrumbs;
